import React from 'react';
import { Box } from '@mui/material';

import OwnCollectionOverviewEmptyState from '../OwnCollectionOverview/OwnCollectionOverviewEmptyState';
import ItemsList from '../ItemsList';
import { hasNext } from '../../utils/pagination';
import { routes } from '../../constants';
import { Collection, Pagination } from '../../types/AppContent';
import { AsyncActionStatus } from '../../actions/common.actionTypes';
import useResponsivePadding from '../../utils/useResponsivePadding';

interface CuratedCollectionOverviewItemsListProps {
  collection: Collection;
  collectionStatus: AsyncActionStatus;
  collectionId: string;
  collectionPagination: Pagination;
  loadNext: () => void;
}

const CuratedCollectionOverviewItemsList = ({
  collection,
  collectionStatus,
  collectionId,
  collectionPagination,
  loadNext,
}: CuratedCollectionOverviewItemsListProps) => {
  const cardPadding = useResponsivePadding();

  return (
    collection.contentsCount === 0 ? <OwnCollectionOverviewEmptyState/> :
      <Box
        data-testid='curated-collection-overview-items-list'
        sx={{
          padding: `${0} ${cardPadding} ${cardPadding} ${cardPadding}`
        }}
      >
        <ItemsList
          isLoading={collectionStatus === 'loading'}
          hasNext={hasNext(collectionPagination)}
          total={collectionPagination.total}
          loadNext={loadNext}
          items={collection.contents}
          linkRoot={[routes.followed.root, collectionId]}
        />
      </Box>
  );
};

export default CuratedCollectionOverviewItemsList;
